import { render, staticRenderFns } from "./index.vue?vue&type=template&id=190e0d1d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e0d1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190e0d1d')) {
      api.createRecord('190e0d1d', component.options)
    } else {
      api.reload('190e0d1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=190e0d1d&scoped=true", function () {
      api.rerender('190e0d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/echarts/index.vue"
export default component.exports